import { Outlet } from 'react-router-dom';
import DJNavbar from '@/components/organisms/DJNavbar';
import DJFooter from '@/components/atoms/DJFooter';

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-dj-black">
      <DJNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <DJFooter />
    </div>
  );
}
